import axios from "../../utilis/axios";

export const getLikes = async ({ id, likes }) => {
  console.log(id, likes);
  const res = await axios.patch(
    `/videos/${id}`,
    { likes: likes + 1 },
    {
      headers: { "Content-type": "application/json; charset=UTF-8" },
    }
  );
  // console.log(res);
  return res.data;
};

export const getUnLikes = async ({ id, unlikes }) => {
  const res = await axios.patch(
    `/videos/${id}`,
    { unlikes: unlikes + 1 },
    {
      headers: { "Content-type": "application/json; charset=UTF-8" },
    }
  );
  // console.log(res);
  return res.data;
};
